<template>
	<div>
		<el-dialog :title="$t('DataRecycling.SetDisplayFields')" :visible.sync="dialogVisible" width="1400px" :close-on-click-modal="false">
			<div class="settingBox">
				<div class="left fieldBox">
					<el-table :data="leftTableData" border height="450">
						<el-table-column prop="chfieldName" align="center" :label="$t('DataRecycling.SampleFields')"></el-table-column>
						<el-table-column align="center" :label="$t('DataRecycling.WhetherToChoose')">
							<template slot-scope="scope">
								<el-checkbox v-model="scope.row.field1"></el-checkbox>
							</template>
						</el-table-column>
						<el-table-column align="center" :label="$t('DataRecycling.IsItFixedOnTheLeftSide')">
							<template slot-scope="scope">
								<el-checkbox v-model="scope.row.field2"></el-checkbox>
							</template>
						</el-table-column>
					</el-table>
					<div class="leftTableChecked"><el-checkbox v-model="leftTableChecked" @change="leftChecked"></el-checkbox></div>
				</div>
				<div class="center fieldBox">
					<el-table :data="centerTableData" border height="450">
						<el-table-column width="160" prop="questionsName" align="center" :label="$t('DataRecycling.QuestionnaireFields')"></el-table-column>
						<el-table-column align="center" :label="$t('DataRecycling.WhetherToChoose')">
							<template slot-scope="scope">
								<el-checkbox v-model="scope.row.field1"></el-checkbox>
							</template>
						</el-table-column>
						<el-table-column align="center" :label="$t('DataRecycling.IsItFixedOnTheLeftSide')">
							<template slot-scope="scope">
								<el-checkbox v-model="scope.row.field2"></el-checkbox>
							</template>
						</el-table-column>
					</el-table>
					<div class="centerTableChecked"><el-checkbox v-model="centerTableChecked" @change="centerChecked"></el-checkbox></div>
				</div>
				<div class="right fieldBox">
					<el-table :data="rightTableData" border height="450">
						<el-table-column width="160" prop="chfieldName" align="center" :label="$t('DataRecycling.VisitorField')"></el-table-column>
						<el-table-column align="center" :label="$t('DataRecycling.WhetherToChoose')">
							<template slot-scope="scope">
								<el-checkbox v-model="scope.row.field1"></el-checkbox>
							</template>
						</el-table-column>
						<el-table-column align="center" :label="$t('DataRecycling.IsItFixedOnTheLeftSide')">
							<template slot-scope="scope">
								<el-checkbox v-model="scope.row.field2"></el-checkbox>
							</template>
						</el-table-column>
					</el-table>
					<div class="rightTableChecked"><el-checkbox v-model="rightTableChecked" @change="rightChecked"></el-checkbox></div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="medium" @click="dialogVisible = false" :loading="loading">{{$t('main.cancel2')}}</el-button>
				<el-button size="medium" type="primary" @click="setShowField" :loading="loading">{{$t('main.ok2')}}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
export default {
	data() {
		return {
			loading: false,
			updateSetID: '',
			surveyId: '',
			dialogVisible: false,
			leftTableData: [],
			leftTableChecked: false,
			rightTableData: [
				{
					chfieldName: this.$t('DataRecycling.FullName'),
					enfieldName: 'username',
					field1: false,
					field2: false
				},
				{
					chfieldName: this.$t('DataRecycling.Age'),
					enfieldName: 'age',
					field1: false,
					field2: false
				},
				{
					chfieldName: this.$t('DataRecycling.Gender'),
					enfieldName: 'sex',
					field1: false,
					field2: false
				},
				{
					chfieldName: this.$t('DataRecycling.Education'),
					enfieldName: 'education',
					field1: false,
					field2: false
				},
				{
					chfieldName: this.$t('DataRecycling.CellPhoneNumber'),
					enfieldName: 'contactNumber',
					field1: false,
					field2: false
				},
				{
					chfieldName: this.$t('DataRecycling.Mailbox'),
					enfieldName: 'email',
					field1: false,
					field2: false
				},
				{
					chfieldName: this.$t('DataRecycling.ID'),
					enfieldName: 'idNumber',
					field1: false,
					field2: false
				},
				{
					chfieldName: this.$t('DataRecycling.Address'),
					enfieldName: 'address',
					field1: false,
					field2: false
				}
			],
			rightTableChecked: false,
			centerTableData: [],
			centerTableChecked: false
		};
	},
	methods: {
		// 右侧全选
		rightChecked(val) {
			console.log(val);
			if (val) {
				this.rightTableData.forEach(item => {
					item.field1 = true;
				});
			} else {
				this.rightTableData.forEach(item => {
					item.field1 = false;
				});
			}
		},
		//中间全选
		centerChecked(val) {
			console.log(val);
			if (val) {
				this.centerTableData.forEach(item => {
					item.field1 = true;
				});
			} else {
				this.centerTableData.forEach(item => {
					item.field1 = false;
				});
			}
		},
		// 左侧全选
		leftChecked(val) {
			console.log(val);
			if (val) {
				this.leftTableData.forEach(item => {
					item.field1 = true;
				});
			} else {
				this.leftTableData.forEach(item => {
					item.field1 = false;
				});
			}
		},
		// 设置显示字段信息
		setShowField() {
			this.loading = true;
			// 左侧样本
			let leftTableData = JSON.parse(JSON.stringify(this.leftTableData));
			// 样本字段
			let sampleField = [];
			let sampleFieldName = [];
			// 是否左侧
			let sampleFieldLeft = [];
			let sampleFieldNameLeft = [];
			// 是否选用
			let sampleFieldShow = [];
			let sampleFieldNameShow = [];
			// 左侧
			leftTableData.forEach(item => {
				sampleField.push(item.enfieldName);
				sampleFieldName.push(item.chfieldName);
				if (item.field1) {
					sampleFieldShow.push(item.enfieldName);
					sampleFieldNameShow.push(item.chfieldName);
				}
				if (item.field2) {
					sampleFieldLeft.push(item.enfieldName);
					sampleFieldNameLeft.push(item.chfieldName);
				}
			});
			// 中间问卷
			let centerTableData = JSON.parse(JSON.stringify(this.centerTableData));
			// 样本字段
			let questionnaireField = [];
			let questionnaireFieldName = [];
			// 是否左侧
			let questionnaireFieldLeft = [];
			let questionnaireFieldNameLeft = [];
			// 是否选用
			let questionnaireFieldShow = [];
			let questionnaireFieldNameShow = [];
			// 中间
			centerTableData.forEach(item => {
				questionnaireField.push(item.qid);
				questionnaireFieldName.push(item.questionsName);

				if (item.field1) {
					questionnaireFieldShow.push(item.qid);
					questionnaireFieldNameShow.push(item.questionsName);
				}
				if (item.field2) {
					questionnaireFieldLeft.push(item.qid);
					questionnaireFieldNameLeft.push(item.questionsName);
				}
			});
			// 右侧访员
			let rightTableData = JSON.parse(JSON.stringify(this.rightTableData));
			// 样本字段
			let interviewerField = [];
			let interviewerFieldName = [];
			// 是否左侧
			let interviewerFieldLeft = [];
			let interviewerFieldNameLeft = [];
			// 是否选用
			let interviewerFieldShow = [];
			let interviewerFieldNameShow = [];
			// 右侧
			rightTableData.forEach(item => {
				interviewerField.push(item.enfieldName);
				interviewerFieldName.push(item.chfieldName);
				if (item.field1) {
					interviewerFieldShow.push(item.enfieldName);
					interviewerFieldNameShow.push(item.chfieldName);
				}
				if (item.field2) {
					interviewerFieldLeft.push(item.enfieldName);
					interviewerFieldNameLeft.push(item.chfieldName);
				}
			});

			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.fieldConfAddOrUpdate}`,
				method: 'POST',
				data: {
					surveyId: this.surveyId,
					id: this.updateSetID,

					sampleField: sampleField.toString(),
					sampleFieldName: sampleFieldName.toString(),
					sampleFieldLeft: sampleFieldLeft.toString(),
					sampleFieldNameLeft: sampleFieldNameLeft.toString(),
					sampleFieldShow: sampleFieldShow.toString(),
					sampleFieldNameShow: sampleFieldNameShow.toString(),

					questionnaireField: questionnaireField.toString(),
					questionnaireFieldName: questionnaireFieldName.toString(),
					questionnaireFieldLeft: questionnaireFieldLeft.toString(),
					questionnaireFieldNameLeft: questionnaireFieldNameLeft.toString(),
					questionnaireFieldShow: questionnaireFieldShow.toString(),
					questionnaireFieldNameShow: questionnaireFieldNameShow.toString(),

					interviewerField: interviewerField.toString(),
					interviewerFieldName: interviewerFieldName.toString(),
					interviewerFieldLeft: interviewerFieldLeft.toString(),
					interviewerFieldNameLeft: interviewerFieldNameLeft.toString(),
					interviewerFieldShow: interviewerFieldShow.toString(),
					interviewerFieldNameShow: interviewerFieldNameShow.toString()
				},
				cb(res) {
					console.log(res);
					if (res.code == 0) {
						that.loading = false;
						that.dialogVisible = false;
						that.leftTableData = [];
						that.rightTableData = [];
						that.centerTableData = [];
						that.$emit('setShowFieldOk');
						that.$message.success(res.message);
					} else {
						that.loading = false;
						that.dialogVisible = false;
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		openSettings() {
			this.surveyId = sessionStorage.getItem('wid');
			// this.queryAllQuestionnaire(); //获取中间问卷字段
			// this.queryAllFieldName(); //获取左侧样本字段
			Promise.all([this.queryAllQuestionnaire(), this.queryAllFieldName()])
				.then(() => {
					this.loadData();
				})
				.catch(err => {
					// 抛出错误信息
				});
			this.rightTableData = [
				{
					chfieldName: this.$t('DataRecycling.FullName'),
					enfieldName: 'username',
					field1: false,
					field2: false
				},
				{
					chfieldName: this.$t('DataRecycling.Age'),
					enfieldName: 'age',
					field1: false,
					field2: false
				},
				{
					chfieldName: this.$t('DataRecycling.Gender'),
					enfieldName: 'sex',
					field1: false,
					field2: false
				},
				{
					chfieldName: this.$t('DataRecycling.Education'),
					enfieldName: 'education',
					field1: false,
					field2: false
				},
				{
					chfieldName: this.$t('DataRecycling.CellPhoneNumber'),
					enfieldName: 'contactNumber',
					field1: false,
					field2: false
				},
				{
					chfieldName: this.$t('DataRecycling.Mailbox'),
					enfieldName: 'email',
					field1: false,
					field2: false
				},
				{
					chfieldName: this.$t('DataRecycling.ID'),
					enfieldName: 'idNumber',
					field1: false,
					field2: false
				},
				{
					chfieldName: this.$t('DataRecycling.Address'),
					enfieldName: 'address',
					field1: false,
					field2: false
				}
			];
			let timer = setTimeout(() => {
				this.dialogVisible = true;
			}, 300);
		},
		loadData() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.fieldConfDetails}?id=${this.surveyId}`,
				method: 'GET',
				data: {},
				cb(res) {
					console.log(res);
					if (res.code == 0) {
						// if (res.resultBody.id == '') {
						// 	// 添加
						// } else {
						// 编辑 样本
						that.updateSetID = res.resultBody.id;
						let sampleFieldShow = res.resultBody.sampleFieldShow.split(',');
						let sampleFieldLeft = res.resultBody.sampleFieldLeft.split(',');
						let tempLeftNum = 0;
						that.leftTableData.forEach(item => {
							sampleFieldLeft.forEach(Leftitem => {
								if (Leftitem == item.enfieldName) {
									item.field2 = true;
								}
							});
							sampleFieldShow.forEach(showitem => {
								if (showitem == item.enfieldName) {
									item.field1 = true;
								}
							});
						});
						sampleFieldShow.forEach(showitem => {
							tempLeftNum++;
						});
						
						let sampleField = [];
						if (res.resultBody.interviewerField != '') {
							sampleField = res.resultBody.sampleField.split(',');
						} else {
							sampleField = [];
						}
						
						that.leftTableChecked = false;
						if (tempLeftNum == sampleField.length) {
							that.leftTableChecked = true;
						}

						// 中间
						let questionnaireFieldLeft = res.resultBody.questionnaireFieldLeft.split(',');
						let questionnaireFieldShow = res.resultBody.questionnaireFieldShow.split(',');
						let tempCenterNum = 0;
						that.centerTableData.forEach(item => {
							questionnaireFieldLeft.forEach(Leftitem => {
								if (Leftitem == item.qid) {
									item.field2 = true;
								}
							});
							questionnaireFieldShow.forEach(showitem => {
								if (showitem == item.qid) {
									item.field1 = true;
								}
							});
						});
						questionnaireFieldShow.forEach(showitem => {
							tempCenterNum++;
						});
						
						let questionnaireField = [];
						if (res.resultBody.interviewerField != '') {
							questionnaireField = res.resultBody.questionnaireField.split(',');
						} else {
							questionnaireField = [];
						}
						
						that.centerTableChecked = false;
						if (tempCenterNum == questionnaireField.length) {
							that.centerTableChecked = true;
						}

						// 右侧
						let interviewerFieldLeft = res.resultBody.interviewerFieldLeft.split(',');
						let interviewerFieldShow = res.resultBody.interviewerFieldShow.split(',');
						let tempRightNum = 0;
						that.rightTableData.forEach(item => {
							interviewerFieldLeft.forEach(Leftitem => {
								if (Leftitem == item.enfieldName) {
									item.field2 = true;
								}
							});
							interviewerFieldShow.forEach(showitem => {
								if (showitem == item.enfieldName) {
									item.field1 = true;
								}
							});
						});
						interviewerFieldShow.forEach(showitem => {
							tempRightNum++;
						});
						let interviewerField = [];
						if (res.resultBody.interviewerField != '') {
							interviewerField = res.resultBody.interviewerField.split(',');
						} else {
							interviewerField = [];
						}
						that.rightTableChecked = false;
						if (tempRightNum == interviewerField.length) {
							that.rightTableChecked = true;
						}
						// }
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		delHtmlTag(str) {
			return str.replace(/<[^>]+>/g, '');
		},
		queryAllQuestionnaire() {
			return new Promise((resolve, reject) => {
				let that = this;
				let params = {
					that: this,
					url: `${this.$config.service.questionlist}?id=${this.surveyId}`,
					method: 'GET',
					data: {},
					cb(res) {
						if (res.code == 0) {
							let centerTableData = JSON.parse(res.resultBody.tbExamPaper.paperjson).questionsList;
							console.log(centerTableData);
							centerTableData.forEach((item, index) => {
								if (item.questionsTypeId == '26') {
									centerTableData.splice(index, 1);
								}
							});
							centerTableData.forEach(item => {
								item.field1 = false;
								item.field2 = false;
								item.questionsName = that.delHtmlTag(item.questionsName);
							});
							that.centerTableData = centerTableData;
							resolve();
						} else {
							that.centerTableData = [];
							that.$message.error(res.message);
							resolve();
						}
					}
				};
				this.$util.request(params);
			});
		},
		queryAllFieldName() {
			return new Promise((resolve, reject) => {
				let that = this;
				let params = {
					that: this,
					url: `${this.$config.service.queryAllFieldName}`,
					method: 'POST',
					data: {
						qid: this.surveyId
					},
					cb(res) {
						if (res.code == 0) {
							let leftTableData = res.resultBody.questionsFieldMappings;
							leftTableData.forEach(item => {
								if (item.field1 == '') {
									item.field1 = false;
								}
								if (item.field2 == '') {
									item.field2 = false;
								}
							});
							that.leftTableData = leftTableData;
							resolve();
						} else {
							that.leftTableData = [];
							that.$message.error(res.message);
							resolve();
						}
					}
				};
				this.$util.request(params);
			});
		}
	}
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
	padding: 20px 0px;
}
.settingBox {
	width: 1400px;
	display: flex;
	justify-content: space-between;
	margin: 0px;
	.fieldBox {
		width: 440px;
	}
	.left {
		margin-left: 20px;
		position: relative;
		.leftTableChecked {
			position: absolute;
			top: 15px;
			left: 250px;
		}
	}
	.center {
		position: relative;
		.centerTableChecked {
			position: absolute;
			top: 15px;
			left: 260px;
		}
	}
	.right {
		margin-right: 20px;
		position: relative;
		.rightTableChecked {
			position: absolute;
			top: 15px;
			left: 260px;
		}
	}
}
</style>
